import http from './http'
// import config from '@/utils/config'

const supplierPayment = `/SupplierPayment`

function getPaymentPagesListBySupplier(params) {
    return http.post(`${supplierPayment}/getPaymentPagesList`, params)
}
function getPaymentLogsBySupplier(params) {
  return http.get(`${supplierPayment}/getPaymentLogs`, params)
}
function approvalBySupplier(params) {
  return http.post(`${supplierPayment}/approval`, params)
}
function addPaymentBySupplier(params) {
  return http.post(`${supplierPayment}/addPayment`, params)
}
function getSupplierPaymentVerifyDetails(params) {
  return http.get(`${supplierPayment}/getSupplierPaymentVerifyDetails`, params)
}
export { getPaymentPagesListBySupplier, getPaymentLogsBySupplier, approvalBySupplier, addPaymentBySupplier, getSupplierPaymentVerifyDetails }
